import { AlertTost, CustomInput } from "#components";
import usePost from "#hooks/usePost.js";
import { WebLayout } from "#layouts";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { changePasswordInitialValues } from "#validations/initialValues.js";
import { changePasswordValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const ChangePassword = () => {
  const [isActive, setIsActive] = useState({
    oldPassword: false,
    password: false,
    confirmPassword: false,
  });
  const {
    mutateAsync: changePasswordMutateAsync,
    isLoading: isLoadingChangePassword,
  } = usePost(ENDPOINTS.CHANGE_PASSWORD, QUERY_KEYS.CHANGE_PASSWORD_QUERY_KEY);
  const nav = useNavigate();
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: changePasswordInitialValues,
    validationSchema: changePasswordValidationSchema,
    onSubmit: async (values) => {
      const data = {
        oldPassword: values?.oldPassword,
        newPassword: values?.password,
      };
      try {
        const response = await changePasswordMutateAsync(data);
        AlertTost(response?.message, "success");
        resetForm();
        nav(WebRoutePath.DASHBOARD.path);
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });
  function handlePasswordVisible(data) {
    setIsActive((prev) => ({
      ...prev,
      [data]: !prev[data],
    }));
  }
  const handelCancel = () => {
    resetForm();
    nav(WebRoutePath.DASHBOARD.path);
  };
  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form className="detail_card_wrapper" onSubmit={handleSubmit}>
                <div className="form-inner-div">
                  <CustomInput
                    label="Old Password"
                    type={isActive.oldPassword ? "text" : "password"}
                    placeholder="Enter your old password"
                    name="oldPassword"
                    value={values.oldPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.oldPassword}
                    touched={touched.oldPassword}
                  />
                  <div
                    onClick={() => handlePasswordVisible("oldPassword")}
                    className="password-eye"
                  >
                    {isActive.oldPassword ? (
                      <RiEyeCloseLine />
                    ) : (
                      <MdOutlineRemoveRedEye />
                    )}
                  </div>
                </div>
                <div className="form-inner-div">
                  <CustomInput
                    label="New Password"
                    type={isActive.password ? "text" : "password"}
                    placeholder="Enter your new password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.password}
                    touched={touched.password}
                  />
                  <div
                    onClick={() => handlePasswordVisible("password")}
                    className="password-eye"
                  >
                    {isActive.password ? (
                      <RiEyeCloseLine />
                    ) : (
                      <MdOutlineRemoveRedEye />
                    )}
                  </div>
                </div>
                <div className="form-inner-div">
                  <CustomInput
                    label="Confirm Password"
                    type={isActive.confirmPassword ? "text" : "password"}
                    placeholder="Enter your confirm  password"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.confirmPassword}
                    touched={touched.confirmPassword}
                  />
                  <div
                    onClick={() => handlePasswordVisible("confirmPassword")}
                    className="password-eye"
                  >
                    {isActive.confirmPassword ? (
                      <RiEyeCloseLine />
                    ) : (
                      <MdOutlineRemoveRedEye />
                    )}
                  </div>
                  <div className="common-change-password-btns">
                    <button
                      class="secondary-btn"
                      type="button"
                      onClick={() => handelCancel()}
                    >
                      Cancel
                    </button>

                    <button class="btn primary-btn">
                      {isLoadingChangePassword ? (
                        <ClipLoader size={17} color="#fff" />
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default ChangePassword;
